// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const loadProtobufRequestFunctions = () => import(/* webpackChunkName: "4-feat-protobuf-request" */ './request');
